<template>
    <v-btn
        class="white--text ma-4"
        @click="toReading"
        color="light-blue darken-4"
    >
        <v-icon class="blue--text text--lighten-3">{{ icons.bookOpen }}</v-icon>
        <span class="ml-2">View Reading List</span>
    </v-btn>
</template>

<script>
import { mdiBookOpenVariant } from '@mdi/js'

export default {
    name: 'HeroReadingButton',
    data() {
        return {
            icons: {
                bookOpen: mdiBookOpenVariant,
            },
        }
    },
    methods: {
        toReading() {
            this.$vuetify.goTo('#reading')
        },
    },
}
</script>

<style scoped>

</style>